import gql from "graphql-tag";

export const ADD_MASTER_CREW_SCHEDULES = gql`
  mutation addMasterCrewSchedules($data: MasterCrewSchedulesInput!) {
    addMasterCrewSchedules(data: $data)
  }
`;